// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title___IKKf","selects":"Documents_selects__33Yay"};